import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { Mail } from "@mui/icons-material";

import { useTranslation } from "react-i18next";
import { ContactPopoverStyles } from "../../Layout.styles";

interface Props {
  onClose: () => void;
  open: boolean;
  anchorEl: any;
}

export function ContactPopover(props: Props) {
  const { anchorEl, onClose, open } = props;
  const { t } = useTranslation();
  const contactEmail = "info@bonisoft.de";
  const feedbackEmail = "feedback@bonisoft.de"

  return (
    <>
    <ContactPopoverStyles
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={open}
      onClose={onClose}
    >
      <Box>
        <Typography variant="overline">{t('contact.title')}</Typography>
        
        <List disablePadding>
          <ListItem disablePadding>
            <ListItemButton onClick={() => window.location.href = `mailto:${contactEmail}`}>
              <ListItemIcon sx={{ minWidth: 40 }}>
                <Mail sx={{ fontSize: "25px" }} />
              </ListItemIcon>
              <ListItemText
                primary={t('contact.emailLabel')}
                slotProps={{
                  primary: { variant: 'body1', sx: { fontSize: '0.8rem' } },
                  secondary: { sx: { fontSize: '0.8rem' } },
                }}
                secondary={contactEmail}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => window.location.href = `mailto:${feedbackEmail}`}>
              <ListItemIcon sx={{ minWidth: 40 }}>
                <Mail sx={{ fontSize: "25px" }} />
              </ListItemIcon>
              <ListItemText
                primary={t('contact.feedbackEmailLabel')}
                slotProps={{
                  primary: { variant: 'body1', sx: { fontSize: '0.8rem' } },
                  secondary: { sx: { fontSize: '0.8rem' } },
                }}
                secondary={feedbackEmail}
              />
            </ListItemButton>
          </ListItem>
        </List>

        {/* <Divider sx={{ my: 1 }} /> */}

        {/* <Box sx={{ px: 2, py: 1 }}>
          <Typography variant="caption" sx={{ fontWeight: 'bold', display: 'block' }}>
              {t('contact.availability')}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {t('contact.hours')}
            </Typography>
        </Box> */}
      </Box>
    </ContactPopoverStyles>
    </>
  );
}